import _defineBuiltIn from "../internals/define-built-in";
var exports = {};
var defineBuiltIn = _defineBuiltIn;
exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};
export default exports;